import { FunctionComponent, useState } from 'react'
import styles from './reservationSettings.module.scss'
import Title from '@/components/_custom/Title/title'
import { Table, TableBody, TableCell, TableRow } from '@mui/material'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique'
import { useMutation } from '@apollo/client'
import { ACTIVE_MERGER, DEACTIVE_MERGER } from '@/modules/API/slot/merger'
import { SelectOptionsDeprecated } from '@/types/Select'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import { useAuth } from '@/modules/context/AuthContext'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ReservationSettingsProps {
    daycare: Daycare
    setMergerActive: (value: boolean) => void
}

enum mergerType {
    RESTRICTED = 'restricted',
    FLEXIBLE = 'flexible'
}

const ReservationSettings: FunctionComponent<ReservationSettingsProps> = ({
    daycare,
    setMergerActive
}: ReservationSettingsProps) => {
    const { t } = useTranslation()

    const { fetchCurrentDaycare } = useAuth()

    const { showNotificationSuccess } = useNotification()

    const [activeMerger] = useMutation(ACTIVE_MERGER, {
        variables: {
            daycareId: daycare.id
        },
        onCompleted: () => {
            fetchCurrentDaycare()

            setMergerActive(true)

            showNotificationSuccess(t('flexibleActive'))
        }
    })
    const [deactiveMerger] = useMutation(DEACTIVE_MERGER, {
        variables: {
            daycareId: daycare.id
        },
        onCompleted: () => {
            fetchCurrentDaycare()

            setMergerActive(false)

            showNotificationSuccess(t('restrictedActive'))
        }
    })

    const [selectValues, setSelectValues] = useState<string>(
        daycare.merger ? mergerType.FLEXIBLE : mergerType.RESTRICTED
    )

    const selectOptions: SelectOptionsDeprecated = [
        {
            options: [
                {
                    name: t('restricted'),
                    value: mergerType.RESTRICTED
                },
                {
                    name: t('flexible'),
                    value: mergerType.FLEXIBLE
                }
            ]
        }
    ]

    function handleSelectChange(value: string): void {
        setSelectValues(value)

        if (value === mergerType.FLEXIBLE) {
            activeMerger()
        } else if (value === mergerType.RESTRICTED) {
            deactiveMerger()
        }
    }

    return (
        <div className={styles.Form}>
            <div className={styles.TitleAndButton}>
                <Title text={t('myReservationSettings')} className={styles.Title} />
            </div>
            <div className={styles.Container}>
                <div className={styles.InputContainer}>
                    <Table className={styles.SettingsTable}>
                        <TableBody>
                            <TableRow>
                                <TableCell className={`${styles.HideBorder} ${styles.RowText}`}>
                                    {t('reservationMode')}
                                </TableCell>
                                <TableCell className={styles.HideBorder}>
                                    <SelectUnique
                                        selectOptions={selectOptions}
                                        selectValue={selectValues}
                                        setSelectValue={handleSelectChange}
                                        formClassName={styles.UserInput}
                                    />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            </div>
        </div>
    )
}

export default ReservationSettings
